<template>
    <div>
        <x-table-server ref="refStoreTableServer"
                        :title="title"
                        :resource="resource"
                        :show-filter="true"
                        :show-button-new="true"
                        :show-button-export="true"
                        :reload-table-server.sync="reloadTableServer"
                        @click-create="clickCreate()">
            <template v-slot:table-rows="props">
                <tr v-for="row in props.records">
                    <td v-for="col in props.columns" :class="col.class_col_body" :key="col['name']">
                        <template v-if="col['name'] === 'actions'">
                            <x-button-icon icon="fal fa-edit"
                                           is-small
                                           type="primary"
                                           v-if="row.btn_edit"
                                           @click="clickCreate(row.id)"></x-button-icon>
                            <x-button-icon icon="fal fa-check"
                                           is-small
                                           type="success"
                                           tooltip-content="Confirmar reservación"
                                           v-if="row.btn_confirm"
                                           @click="clickConfirm(row.id)"></x-button-icon>
                            <x-button-icon icon="fal fa-xmark"
                                           is-small
                                           type="danger"
                                           tooltip-content="Cancelar reservación"
                                           v-if="row.btn_cancel"
                                           @click="clickCancel(row.id)"></x-button-icon>
                            <x-button-icon icon="fal fa-hand-point-right"
                                           is-small
                                           type="danger"
                                           tooltip-content="Check In"
                                           v-if="row.btn_check_in"
                                           @click="clickCheckIn(row)"></x-button-icon>
                        </template>
                        <template v-else>
                            {{ row[col['name']] }}
                        </template>
                    </td>
                </tr>
            </template>
        </x-table-server>

        <reservation-form :show-dialog.sync="showDialogForm"
                          :record-id="recordId"
                          :resource="resource"
                          @success="reloadTableServer = true"></reservation-form>
    </div>
</template>

<script>

import XTableServer from "../../../../components/Form/XTableServer.vue";
import ReservationForm from "./Form.vue";
import XButtonPrimary from "../../../../components/Form/XButtonPrimary.vue";
import XButtonDownload from "../../../../components/Form/XButtonDownload.vue";
import XButtonIcon from "../../../../components/Form/XButtonIcon.vue";

export default {
    name: 'InventoryGuideIndex',
    components: {
        XButtonIcon, XButtonDownload, XButtonPrimary, ReservationForm, XTableServer
    },
    data() {
        return {
            title: 'Reservaciones',
            resource: 'hotel/reservations',
            recordId: null,
            showDialogForm: false,
            showDialogInformation: false,
            reloadTableServer: false,
        }
    },
    methods: {
        clickCreate(id = null) {
            this.recordId = id;
            this.showDialogForm = true;
        },
        clickCancel(id) {
            this.$confirm('¿Desea cancelar la reservación?', 'Cancelar', {
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(async () => {
                await this.$http.get(`/${this.resource}/cancel/${id}`)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.reloadTableServer = true
                        } else {
                            this.$message.error(response.data.message)
                        }
                });
            }).catch(() => {});
        },
        clickConfirm(id) {
            this.$confirm('¿Desea confirmar la reservación?', 'Confirmar', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(async () => {
                await this.$http.get(`/${this.resource}/confirm/${id}`)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.reloadTableServer = true
                        } else {
                            this.$message.error(response.data.message)
                        }
                    });
            }).catch(() => {});
        },
        clickCheckIn(row) {
            this.$confirm('¿Desea hacer check in de la reservación?', 'Confirmar', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
                window.location.href = `/hotel/receptions/rent/${row.room_id}/${row.id}`
            }).catch(() => {});
        },
    }
}
</script>
